// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionPlanNewActionMenu_wrapper__GrNwc {
  position: relative;
  margin-top: 12px;
}

.ActionPlanNewActionMenu_directWrapper__7nNnt {
  width: 100%;
}

.ActionPlanNewActionMenu_trigger__J4ehu,
.ActionPlanNewActionMenu_directTrigger__gV\\+Rk {
  width: 100%;
  min-height: 42px;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid #d3dce3;
  border-radius: 8px;
  background: #fff;
  color: #284861;
  cursor: pointer;
  font-size: 0.88rem;
  text-align: left;
}

.ActionPlanNewActionMenu_trigger__J4ehu {
  display: grid;
  grid-template-columns: auto 1fr auto;
}

.ActionPlanNewActionMenu_directTrigger__gV\\+Rk {
  display: flex;
  justify-content: flex-start;
  min-height: 48px;
  border-color: #286786;
  font-weight: 600;
}

.ActionPlanNewActionMenu_directTrigger__gV\\+Rk > span:first-child {
  font-size: 1.25rem;
  font-weight: 400;
}

.ActionPlanNewActionMenu_directTrigger__gV\\+Rk:hover {
  background: #f7fbfd;
}

.ActionPlanNewActionMenu_chevron__PjBSu {
  color: #758792;
  font-size: 1rem;
}

.ActionPlanNewActionMenu_menu__\\+0nBX {
  position: absolute;
  z-index: 40;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(28, 48, 64, 0.16);
}

.ActionPlanNewActionMenu_menu__\\+0nBX button {
  padding: 13px 16px;
  border: 0;
  border-bottom: 1px solid #edf1f3;
  background: #fff;
  color: #142d3e;
  cursor: pointer;
  text-align: left;
  font-size: 0.86rem;
}

.ActionPlanNewActionMenu_menu__\\+0nBX button:last-child {
  border-bottom: 0;
}

.ActionPlanNewActionMenu_menu__\\+0nBX button:hover {
  background: #f7fafb;
}

.ActionPlanNewActionMenu_backdrop__1\\+R7Q {
  position: fixed;
  z-index: 2500;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(18, 37, 50, 0.52);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

.ActionPlanNewActionMenu_modal__n9wtS {
  position: relative;
  width: min(520px, 94vw);
  max-height: 92vh;
  overflow: auto;
  padding: 28px 24px 22px;
  border-top: 5px solid #5ab1d4;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 24px 64px rgba(15, 35, 48, 0.28);
  color: #243847;
}

.ActionPlanNewActionMenu_proposalModal__Wl7k1 {
  width: min(560px, 94vw);
  border-top-color: #ff8b43;
}

.ActionPlanNewActionMenu_close__TVwIN {
  position: absolute;
  top: 16px;
  right: 18px;
  border: 0;
  background: transparent;
  color: #8a99a5;
  cursor: pointer;
  font-size: 1.6rem;
}

.ActionPlanNewActionMenu_modal__n9wtS h2 {
  margin: 0 36px 20px 0;
  color: #173b52;
  font-size: 1.35rem;
}

.ActionPlanNewActionMenu_proposalModal__Wl7k1 h2 {
  margin-bottom: 4px;
  color: #3f3f3f;
  font-size: 1.8rem;
}

.ActionPlanNewActionMenu_subtitle__4TMDc {
  margin: 0 0 22px;
  padding-bottom: 18px;
  border-bottom: 1px solid #edf0f2;
  color: #75808a;
  font-size: 0.9rem;
}

.ActionPlanNewActionMenu_proposalTopBadges__YsL69 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
}

.ActionPlanNewActionMenu_proposalTopBadges__YsL69 > span {
  padding: 6px 11px;
  border-radius: 8px;
  background: #f0f2f3;
  color: #525c64;
  font-size: 0.8rem;
  font-weight: 600;
}

.ActionPlanNewActionMenu_proposalTopBadges__YsL69 .ActionPlanNewActionMenu_valuePreview__N9IcA {
  background: var(--upcare-value-bienveillance-soft);
  color: #b57f00;
}

.ActionPlanNewActionMenu_field__syNps {
  display: block;
  margin-bottom: 16px;
}

.ActionPlanNewActionMenu_field__syNps > span:first-child {
  display: block;
  margin-bottom: 7px;
  color: #596976;
  font-size: 0.82rem;
  font-weight: 600;
}

.ActionPlanNewActionMenu_upperLabel__w7sW6 {
  color: #98a2b3 !important;
  font-size: 0.73rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
}

.ActionPlanNewActionMenu_field__syNps select,
.ActionPlanNewActionMenu_field__syNps input,
.ActionPlanNewActionMenu_field__syNps textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d7dfe5;
  border-radius: 10px;
  background: #f7f8fa;
  color: #415262;
  font: inherit;
}

.ActionPlanNewActionMenu_field__syNps select,
.ActionPlanNewActionMenu_field__syNps input {
  min-height: 40px;
  padding: 9px 12px;
}

.ActionPlanNewActionMenu_field__syNps textarea {
  min-height: 100px;
  resize: vertical;
  padding: 11px 12px;
}

.ActionPlanNewActionMenu_pills__vuI\\+C {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ActionPlanNewActionMenu_pill__pk6KS,
.ActionPlanNewActionMenu_valuePill__De-BU,
.ActionPlanNewActionMenu_selectedNeutralPill__MFH5E,
.ActionPlanNewActionMenu_selectedActionPill__gUAtg,
.ActionPlanNewActionMenu_selectedThemePill__\\+UsRP {
  min-height: 34px;
  padding: 6px 14px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #dbe2e7;
  color: #515d66;
  cursor: pointer;
  font-size: 0.8rem;
}

.ActionPlanNewActionMenu_selectedNeutralPill__MFH5E {
  border-color: #f1ba2a;
  background: #fff7dc;
  color: #b78100;
}

.ActionPlanNewActionMenu_selectedActionPill__gUAtg {
  border-color: #ff8b43;
  background: #fff4ed;
  color: #e46a20;
}

.ActionPlanNewActionMenu_selectedThemePill__\\+UsRP {
  border-color: #2c6f88;
  background: #eaf5f9;
  color: #1d5b73;
  font-weight: 600;
}

.ActionPlanNewActionMenu_valuePill__De-BU[data-value="bienveillance"].ActionPlanNewActionMenu_selectedValuePill__Zrd3o {
  border-color: var(--upcare-value-bienveillance);
  background: var(--upcare-value-bienveillance-soft);
}

.ActionPlanNewActionMenu_valuePill__De-BU[data-value="engagement"].ActionPlanNewActionMenu_selectedValuePill__Zrd3o {
  border-color: var(--upcare-value-engagement);
  background: var(--upcare-value-engagement-soft);
}

.ActionPlanNewActionMenu_valuePill__De-BU[data-value="faire-equipe"].ActionPlanNewActionMenu_selectedValuePill__Zrd3o {
  border-color: var(--upcare-value-faire-equipe);
  background: var(--upcare-value-faire-equipe-soft);
}

.ActionPlanNewActionMenu_valuePill__De-BU[data-value="respect"].ActionPlanNewActionMenu_selectedValuePill__Zrd3o {
  border-color: var(--upcare-value-respect);
  background: var(--upcare-value-respect-soft);
}

.ActionPlanNewActionMenu_error__vDapd {
  margin: 4px 0 12px;
  padding: 9px 10px;
  border-radius: 8px;
  background: #fff0ef;
  color: #b42318;
  font-size: 0.8rem;
}

.ActionPlanNewActionMenu_submit__7LUM1 {
  width: 100%;
  min-height: 44px;
  border: 0;
  border-radius: 12px;
  background: #1a7188;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
}

.ActionPlanNewActionMenu_submit__7LUM1:disabled {
  background: #acc3ce;
  cursor: not-allowed;
}

@media (max-width: 600px) {
  .ActionPlanNewActionMenu_backdrop__1\\+R7Q {
    align-items: flex-end;
    padding: 0;
  }

  .ActionPlanNewActionMenu_modal__n9wtS,
  .ActionPlanNewActionMenu_proposalModal__Wl7k1 {
    width: 100%;
    max-height: 94vh;
    border-radius: 16px 16px 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ActionPlan/ActionPlanNewActionMenu.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;;;;EAKE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;EAC9B;AACF","sourcesContent":[".wrapper {\n  position: relative;\n  margin-top: 12px;\n}\n\n.directWrapper {\n  width: 100%;\n}\n\n.trigger,\n.directTrigger {\n  width: 100%;\n  min-height: 42px;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 12px;\n  border: 1px solid #d3dce3;\n  border-radius: 8px;\n  background: #fff;\n  color: #284861;\n  cursor: pointer;\n  font-size: 0.88rem;\n  text-align: left;\n}\n\n.trigger {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n}\n\n.directTrigger {\n  display: flex;\n  justify-content: flex-start;\n  min-height: 48px;\n  border-color: #286786;\n  font-weight: 600;\n}\n\n.directTrigger > span:first-child {\n  font-size: 1.25rem;\n  font-weight: 400;\n}\n\n.directTrigger:hover {\n  background: #f7fbfd;\n}\n\n.chevron {\n  color: #758792;\n  font-size: 1rem;\n}\n\n.menu {\n  position: absolute;\n  z-index: 40;\n  left: 0;\n  right: 0;\n  top: calc(100% + 6px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 10px 24px rgba(28, 48, 64, 0.16);\n}\n\n.menu button {\n  padding: 13px 16px;\n  border: 0;\n  border-bottom: 1px solid #edf1f3;\n  background: #fff;\n  color: #142d3e;\n  cursor: pointer;\n  text-align: left;\n  font-size: 0.86rem;\n}\n\n.menu button:last-child {\n  border-bottom: 0;\n}\n\n.menu button:hover {\n  background: #f7fafb;\n}\n\n.backdrop {\n  position: fixed;\n  z-index: 2500;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(18, 37, 50, 0.52);\n  backdrop-filter: blur(2px);\n}\n\n.modal {\n  position: relative;\n  width: min(520px, 94vw);\n  max-height: 92vh;\n  overflow: auto;\n  padding: 28px 24px 22px;\n  border-top: 5px solid #5ab1d4;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 24px 64px rgba(15, 35, 48, 0.28);\n  color: #243847;\n}\n\n.proposalModal {\n  width: min(560px, 94vw);\n  border-top-color: #ff8b43;\n}\n\n.close {\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  border: 0;\n  background: transparent;\n  color: #8a99a5;\n  cursor: pointer;\n  font-size: 1.6rem;\n}\n\n.modal h2 {\n  margin: 0 36px 20px 0;\n  color: #173b52;\n  font-size: 1.35rem;\n}\n\n.proposalModal h2 {\n  margin-bottom: 4px;\n  color: #3f3f3f;\n  font-size: 1.8rem;\n}\n\n.subtitle {\n  margin: 0 0 22px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid #edf0f2;\n  color: #75808a;\n  font-size: 0.9rem;\n}\n\n.proposalTopBadges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 18px;\n}\n\n.proposalTopBadges > span {\n  padding: 6px 11px;\n  border-radius: 8px;\n  background: #f0f2f3;\n  color: #525c64;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.proposalTopBadges .valuePreview {\n  background: var(--upcare-value-bienveillance-soft);\n  color: #b57f00;\n}\n\n.field {\n  display: block;\n  margin-bottom: 16px;\n}\n\n.field > span:first-child {\n  display: block;\n  margin-bottom: 7px;\n  color: #596976;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.upperLabel {\n  color: #98a2b3 !important;\n  font-size: 0.73rem !important;\n  font-weight: 700 !important;\n  text-transform: uppercase;\n}\n\n.field select,\n.field input,\n.field textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #d7dfe5;\n  border-radius: 10px;\n  background: #f7f8fa;\n  color: #415262;\n  font: inherit;\n}\n\n.field select,\n.field input {\n  min-height: 40px;\n  padding: 9px 12px;\n}\n\n.field textarea {\n  min-height: 100px;\n  resize: vertical;\n  padding: 11px 12px;\n}\n\n.pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.pill,\n.valuePill,\n.selectedNeutralPill,\n.selectedActionPill,\n.selectedThemePill {\n  min-height: 34px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  background: #fff;\n  border: 1px solid #dbe2e7;\n  color: #515d66;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.selectedNeutralPill {\n  border-color: #f1ba2a;\n  background: #fff7dc;\n  color: #b78100;\n}\n\n.selectedActionPill {\n  border-color: #ff8b43;\n  background: #fff4ed;\n  color: #e46a20;\n}\n\n.selectedThemePill {\n  border-color: #2c6f88;\n  background: #eaf5f9;\n  color: #1d5b73;\n  font-weight: 600;\n}\n\n.valuePill[data-value=\"bienveillance\"].selectedValuePill {\n  border-color: var(--upcare-value-bienveillance);\n  background: var(--upcare-value-bienveillance-soft);\n}\n\n.valuePill[data-value=\"engagement\"].selectedValuePill {\n  border-color: var(--upcare-value-engagement);\n  background: var(--upcare-value-engagement-soft);\n}\n\n.valuePill[data-value=\"faire-equipe\"].selectedValuePill {\n  border-color: var(--upcare-value-faire-equipe);\n  background: var(--upcare-value-faire-equipe-soft);\n}\n\n.valuePill[data-value=\"respect\"].selectedValuePill {\n  border-color: var(--upcare-value-respect);\n  background: var(--upcare-value-respect-soft);\n}\n\n.error {\n  margin: 4px 0 12px;\n  padding: 9px 10px;\n  border-radius: 8px;\n  background: #fff0ef;\n  color: #b42318;\n  font-size: 0.8rem;\n}\n\n.submit {\n  width: 100%;\n  min-height: 44px;\n  border: 0;\n  border-radius: 12px;\n  background: #1a7188;\n  color: #fff;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.submit:disabled {\n  background: #acc3ce;\n  cursor: not-allowed;\n}\n\n@media (max-width: 600px) {\n  .backdrop {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .modal,\n  .proposalModal {\n    width: 100%;\n    max-height: 94vh;\n    border-radius: 16px 16px 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ActionPlanNewActionMenu_wrapper__GrNwc`,
	"directWrapper": `ActionPlanNewActionMenu_directWrapper__7nNnt`,
	"trigger": `ActionPlanNewActionMenu_trigger__J4ehu`,
	"directTrigger": `ActionPlanNewActionMenu_directTrigger__gV+Rk`,
	"chevron": `ActionPlanNewActionMenu_chevron__PjBSu`,
	"menu": `ActionPlanNewActionMenu_menu__+0nBX`,
	"backdrop": `ActionPlanNewActionMenu_backdrop__1+R7Q`,
	"modal": `ActionPlanNewActionMenu_modal__n9wtS`,
	"proposalModal": `ActionPlanNewActionMenu_proposalModal__Wl7k1`,
	"close": `ActionPlanNewActionMenu_close__TVwIN`,
	"subtitle": `ActionPlanNewActionMenu_subtitle__4TMDc`,
	"proposalTopBadges": `ActionPlanNewActionMenu_proposalTopBadges__YsL69`,
	"valuePreview": `ActionPlanNewActionMenu_valuePreview__N9IcA`,
	"field": `ActionPlanNewActionMenu_field__syNps`,
	"upperLabel": `ActionPlanNewActionMenu_upperLabel__w7sW6`,
	"pills": `ActionPlanNewActionMenu_pills__vuI+C`,
	"pill": `ActionPlanNewActionMenu_pill__pk6KS`,
	"valuePill": `ActionPlanNewActionMenu_valuePill__De-BU`,
	"selectedNeutralPill": `ActionPlanNewActionMenu_selectedNeutralPill__MFH5E`,
	"selectedActionPill": `ActionPlanNewActionMenu_selectedActionPill__gUAtg`,
	"selectedThemePill": `ActionPlanNewActionMenu_selectedThemePill__+UsRP`,
	"selectedValuePill": `ActionPlanNewActionMenu_selectedValuePill__Zrd3o`,
	"error": `ActionPlanNewActionMenu_error__vDapd`,
	"submit": `ActionPlanNewActionMenu_submit__7LUM1`
};
export default ___CSS_LOADER_EXPORT___;
